import React from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import StorageIcon from "@mui/icons-material/Storage";
import DataObjectIcon from "@mui/icons-material/DataObject";
import MergeTypeIcon from "@mui/icons-material/MergeType";
import ChatIcon from "@mui/icons-material/Chat";
import AdminReferenceDataEditor from "./AdminReferenceDataEditor";
import AdminFieldsEditor from "./AdminFieldsEditor";
import AdminDataFieldsEditor from "./AdminDataFieldsEditor";
import AdminChatContentEditor from "./AdminChatContentEditor";
import { useAdminSessionState } from "./useAdminSessionState";
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { DATA_TABS, dataTabPath } from './adminNavigation';

const AdminDataEditor = ({ userId }) => {
  const [savedSubTab, setSavedSubTab] = useAdminSessionState(`admin:${userId}:dataTab`, 0);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const activeSubTab = DATA_TABS.indexOf(pathname.split('/')[3]);

  const handleSubTabChange = (event, newValue) => {
    setSavedSubTab(newValue);
    navigate(dataTabPath(newValue));
  };

  if (activeSubTab < 0) return <Navigate to={dataTabPath(savedSubTab)} replace />;

  return (
    <div className="standard-container">
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: 1, borderColor: 'divider', mb: 2 }}>
        <h3 style={{ margin: 0 }}>Data</h3>
        <Tabs
          value={activeSubTab}
          onChange={handleSubTabChange}
          aria-label="data editor tabs"
          textColor="primary"
          indicatorColor="primary"
        >
          <Tab 
            icon={<StorageIcon sx={{ fontSize: 16 }} />} 
            iconPosition="start" 
            label="AI Reference Lists" 
          />
          <Tab 
            icon={<DataObjectIcon sx={{ fontSize: 16 }} />} 
            iconPosition="start" 
            label="Section Schemas" 
          />
          <Tab 
            icon={<MergeTypeIcon sx={{ fontSize: 16 }} />} 
            iconPosition="start" 
            label="Data Fields"
          />
          <Tab 
            icon={<ChatIcon sx={{ fontSize: 16 }} />} 
            iconPosition="start" 
            label="AI Chat Content" 
          />
        </Tabs>
      </Box>

      {activeSubTab === 0 && <AdminReferenceDataEditor />}
      {activeSubTab === 1 && <AdminFieldsEditor />}
      {activeSubTab === 2 && <AdminDataFieldsEditor />}
      {activeSubTab === 3 && <AdminChatContentEditor />}
    </div>
  );
};

export default AdminDataEditor;
